<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <StartInfosForm @submit-requested="submitRequested"></StartInfosForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import StartInfosForm from './StartInfosForm.vue'

  export default {
  components: { StartInfosForm },
  methods: {
    ...mapActions('startInfos', ['postStartInfo']),
    submitRequested (input) {
      this.postStartInfo(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 